import { Component, Directive, EventEmitter, inject, Input, Output, PipeTransform, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ShiftService } from '../../../Model/Shift/shift.service';
import { AsyncPipe, CommonModule, DecimalPipe } from '@angular/common';
import { NgbDropdownModule, NgbHighlight, NgbModal, NgbPaginationModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule, RouterOutlet } from '@angular/router';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject, map, startWith } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CommonService } from '../../../Model/Common/common.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import * as XLSX from 'xlsx';
import { SessionService } from '../../../Util/Session/session.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonUploadComponent } from '../../../Component/CommonUpload/common-upload/common-upload.component';

@Component({
  selector: 'app-shift',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent],
  templateUrl: './shift.component.html',
  styleUrl: './shift.component.scss',
  providers: [DecimalPipe],
})
export class ShiftComponent {
  isDisabled: boolean = false;
  ShiftData: any[] = [];
  TableDatas = [];
  ShiftRecord: any[] = [];
  public User: any = null;
  private modalService = inject(NgbModal);
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  dtoptions: DataTables.Settings = {};
  constructor(
    private shift: ShiftService,
    protected common: CommonService,
    private download: DownloadSampleService,
    private toast: ToastService,
    private Session: SessionService
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.LoadShiftMaster();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  LoadShiftMaster() {
    this.isDisabled = true;
    this.shift.LoadShiftMaster({ SelectType: 1, ShiftMasterid: 0 }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  exportToExcel() {
    this.isDisabled = true
    const data = {
      SelectType: 'ShiftMasterExcel',
      Year: ''
    }
    this.download.ESS_ExcelDump(data).subscribe(
      data => {
        this.ShiftData = data;
        if (this.ShiftData.length > 0) {
          this.download.exportToExcel(this.ShiftData, "Shift_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }

  handleFileInput(event: any): void {
    this.ShiftRecord.length = 0;
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      const file: File = files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);
      event.target.value = '';
    }
  }
  processExcelFile(file: File): void {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        const headerRow = excelData[0];
        const headers = headerRow.map((header: string) => header.trim());
        const dataRows = excelData.slice(1);

        const uniqueshiftIds: Set<number> = new Set();
        this.ShiftRecord = [];

        for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
          const row = dataRows[rowIndex];
          const rowData: any = {};

          row.forEach((cellData, index) => {
            rowData[headers[index]] = cellData;
          });

          const id = rowData['ShiftMasterid'];
          let shiftcode = rowData['ShiftCode'].toString();
          let ShiftTitle = rowData['ShiftTitle'].toString();
          let InTime = rowData['InTime'].toString();
          let OutTime = rowData['OutTime'].toString();
          let DefaultShift = rowData['DefaultShift'].toString();
          let RotationalShift = rowData['RotationalShift'].toString();
          let ShiftGroupName = rowData['ShiftGroupName'].toString();

          shiftcode = shiftcode ? shiftcode.trim() : '';
          ShiftTitle = ShiftTitle ? ShiftTitle.trim() : '';
          InTime = InTime ? InTime.trim() : '';
          OutTime = OutTime ? OutTime.trim() : '';
          DefaultShift = DefaultShift ? DefaultShift.trim() : '';
          RotationalShift = RotationalShift ? RotationalShift.trim() : '';
          ShiftGroupName = ShiftGroupName ? ShiftGroupName.trim() : '';

          if (id !== 0 && id !== '' && id !== undefined && uniqueshiftIds.has(id)) {
            this.toast.show({ message: `Duplicate ShiftMaster ID '${id}' found at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } else {
            uniqueshiftIds.add(id);
          }
          if (shiftcode === '' || shiftcode === null || shiftcode === undefined) {
            this.toast.show({ message: `Shift code is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          if (ShiftTitle === '' || ShiftTitle === null || ShiftTitle === undefined) {
            this.toast.show({ message: `Shift Title is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          if (typeof InTime !== 'string' || InTime === undefined || InTime === null) {
            this.toast.show({ message: `In Time Formate should be in string at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          if (typeof OutTime !== 'string' || OutTime === undefined || OutTime === null) {
            this.toast.show({ message: `Out Time Formate should be in string at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          if (InTime === '' || InTime === null || InTime === undefined) {
            this.toast.show({ message: `In Time is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } if (OutTime === '' || OutTime === null || OutTime === undefined) {
            this.toast.show({ message: `Out Time is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } if (DefaultShift === '' || DefaultShift === null || DefaultShift === undefined) {
            this.toast.show({ message: `Default Shift is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } if (RotationalShift === '' || RotationalShift === null || RotationalShift === undefined) {
            this.toast.show({ message: `Rotational Shift is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          } if (ShiftGroupName === '' || ShiftGroupName === null || ShiftGroupName === undefined) {
            this.toast.show({ message: `Shift Group Name is blank at row ${rowIndex + 1}`, type: toastTypeEnum.danger });
            return;
          }
          rowData['ShiftCode'] = shiftcode;
          rowData['ShiftTitle'] = ShiftTitle;
          rowData['InTime'] = InTime;
          rowData['OutTime'] = OutTime;
          rowData['DefaultShift'] = DefaultShift;
          rowData['RotationalShift'] = RotationalShift;
          rowData['ShiftGroupName'] = ShiftGroupName;

          this.ShiftRecord.push(rowData);
          console.log(this.ShiftRecord)
        }
        this.BulkInsertUpdate(this.ShiftRecord);
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }
  BulkInsertUpdate(Data: any) {
    this.User = this.Session.GetUserDetails();
    if (this.ShiftRecord.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const shiftgroupData = {
      SelectType: 'UPLOAD',
      ESS_ShiftMasterInsert: Data,
      UserId: this.User.UserId,
    };
    this.shift.Proc_ESS_ShiftMaster_BulkInsert(shiftgroupData).subscribe(
      data => {
        if (data.Error_Code == '01') {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.danger });
        }
        this.LoadShiftMaster();
      },
      error => {
        console.error('Error:', error);
      });
  }

  downloadExcel() {
    this.download.downloadExcel('ShiftMaster');
  }

  upload() {
    const modalRef = this.modalService.open(CommonUploadComponent, {
      size: 'lg',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Input_ExcelUploadMasterID = 1;
    modalRef.result.then(result => {
      if (result) {
        this.LoadShiftMaster();
      }
    });
  }
}

